import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { LogoInfo } from '@/common/types';
import { API_URL } from '@/dtos';


interface ExpressSetupOrganizationProperties {
  enabled?: boolean;
  partnerName?: string;
  pricingConsent?: string;
  termsAndConditionsLink?: string;
  privacyPolicyLink?: string;
  logoInfo?: LogoInfo;
}

interface Props {
  distributorId?: string;
}

const useGetExpressSetupPropertiesQuery = ({ distributorId }: Props) => {
  const { data, isLoading, isError } = useQuery(
    [API_URL.EXPRESS_SETUP_ENABLED],
    () =>
      api.get(API_URL.EXPRESS_SETUP_ENABLED, {
        params: {
          distributor_id: distributorId,
        },
      }),
    {
      enabled: !!distributorId,
    }
  );

  const expressSetupProperties: ExpressSetupOrganizationProperties = useMemo(
    (): ExpressSetupOrganizationProperties => ({
      enabled: data?.data?.enable,
      partnerName: data?.data?.partner_name,
      pricingConsent: data?.data?.pricing_consent,
      privacyPolicyLink: data?.data?.privacy_policy_link,
      termsAndConditionsLink: data?.data?.terms_and_conditions_link,
      logoInfo: {
        darkLargeLogoUrl: data?.data?.logo_info?.dark_large_logo_url,
        darkMinimizedLogoUrl: data?.data?.logo_info?.dark_minimized_logo_url,
        faviconUrl: data?.data?.logo_info?.favicon_url,
        largeLogoUrl: data?.data?.logo_info?.large_logo_url,
        minimizedLogoUrl: data?.data?.logo_info?.minimized_logo_url,
      },
    }),
    [data]
  );

  return {
    expressSetupProperties,
    isLoading,
    isError,
  };
};

export default useGetExpressSetupPropertiesQuery;
